type Customer = {
  "/api/a": { request: { id: number }; response: number[] };
  "/customer/a": { request: { id: number }; response: number[] };
};
type Api = {
  "/api/b": { request: { data: number }; response: { data: any }[] };
};

type R = {
  customer: Customer;
  api: Api;
}

type AddUnderscorePrefix<T> = {
    [K in keyof T]: K extends string ? `_${K}` : never
};

type PrefixKeys = AddUnderscorePrefix<R>;

type ResultType = {
    [K in keyof PrefixKeys]: R[Extract<keyof R, K>]
};

// type d={
//   [p in keyofAddUnderscorePrefix<Customer,'customer'>]
// }

export const useRequest = async (api,data) => {
  const config = useRuntimeConfig();

  const res = await fetch(config.public.apiHost + api, {
    method: 'post',
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data)
  })
  try{
    return res.json()
  }catch(error){
    return {
      error
    }
  }
  // const data = await res.json()
};
